module.exports = __webpack_public_path__ + "img/eyes.4bdcc82f.svg";